import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 支付类型
 */
class PayType extends UltMeta {
    WX = new Meta(1, "微信");
    ALI = new Meta(2, "支付宝");
}

export const PAY_TYPE = new PayType();

/**
 * 支付类型
 */
class CustomPayType extends UltMeta {
    WX = new Meta(1, "微信", "icon-Group2/#1AAD19");
    ALI = new Meta(2, "支付宝", "icon-a-Alipay12/#1677FF");
    APPLE = new Meta(3, "苹果支付");
    CHINAUMS = new Meta(4, "银联支付");
}
export const CUSTOM_PAY_TYPE = new CustomPayType();

/**
 * 状态
 */
class State extends UltMeta {
    UNPAID = new Meta(1, "未支付");
    SUCCESS = new Meta(2, "已支付");
    CLOSED = new Meta(3, "已关闭");
    CANCELLED = new Meta(4, "已取消");
}

export const STATE = new State();

/**
 * 支付状态
 */
class PayState extends UltMeta {
    UNPAID = new Meta(1, "未支付");
    SUCCESS = new Meta(2, "支付成功");
    CANCELLED = new Meta(3, "已取消");
    CLOSED = new Meta(4, "已关闭");
    FINISHED = new Meta(5, "已完成");
    REFUND = new Meta(6, "转入退款");
}

export const PAY_STATE = new PayState();

/**
 * 来源
 */
class Source extends UltMeta {
    PC = new Meta(1, "PC");
    MINI_PROGRAM = new Meta(2, "小程序");
}

export const SOURCE = new Source();

/**
 * 业务类型
 */
class BusinessType extends UltMeta {
    MEMBER = new Meta(1, "会员");
    // 对于被 @Deprecated 标注的部分，您可以根据实际需求决定是否保留或进行特殊处理
    SHIPPING_ORDER_DEPOSIT = new Meta(2, "船运单定金");
    SHIP_INFO_SERVICE_FEE = new Meta(3, "船务信息服务费");
}

export const BUSINESS_TYPE = new BusinessType();

/**
 * 类型
 */
class Type extends UltMeta {
    CUSTOMER_MINI_PROGRAM = new Meta(1, "客户小程序");
    CARRIER_MINI_PROGRAM = new Meta(2, "承运商小程序");
}

export const TYPE = new Type();
